export const SocialPlayerSnapchatViewerType =
  'wixui.SocialPlayerSnapchat' as const;

export const TestIds = {
  viewer: {
    iframe: 'SocialPlayerSnapchat-iframe',
  },
} as const;

export const snapChatLogoUrl =
  'https://static.parastorage.com/services/santa-resources/dist/editor/videoUpload/snapchat/snapChatLogo.png';
